import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import CombinedPhases from '../treeComponents/CombinedPhases';
import courseManagementService from '../../service/courseManagementServices';
import {
  getCreateCourseDefaultFormData,
  getCreateCourseInitailStateForErrors,
  checkMinLength,
  isNumericInput,
  checkStartAndEndDate,
  buildComboSKUString,
  isContainSpecialCharacters
} from '../../helpers/helpers';
import { mockData } from '../treeComponents/mockData/ComboMock';
import { mergingTrees } from '.';
import { CourseBasicDetails, CourseBasicDetailsErrors } from '../../types/interfaces/CourseBasicDetails';
import { Goal } from '../../types/interfaces/Goal';
import { Course } from '../../types/interfaces/Course';
import { User } from '../../types/interfaces/User';
import DialogHeader from '../../../userManagement/common/DialogHeader';
import DialogFooter from '../../../userManagement/common/DialogFooter';

import {
  withStyles,
  WithStyles,
  Card,
  CardContent,
  CardActions,
  Checkbox,
  Typography,
  Modal,
  CardHeader,
  IconButton,
  Button,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  Icon,
  Switch,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { MyPATTextField, MyPATDialog, MyPATSelect, dateService } from '../../../common';
import CloseIcon from '@material-ui/icons/Close';
import { courseStyles } from '../../styles';
import MyPATCalendar from '../../../common/MyPATCalendar';
import Autocomplete from '../../../common/Autocomplete';
import {
  getActiveGoals,
  getUserSuggestions,
  addCourseBasicDetails,
  getActiveCourses,
  getActiveTreeData,
} from '../../actions/courseManagementActions';
import _ from 'lodash';
import { courseManagementActions } from '../../reducers/courseManagementReducer';
import contentManagementService from '../../service/courseManagementServices';
import { ContentPreferences } from '../../types/enums/ContentPreferences';
import { DateCheck } from '../../types/enums/DateCheckResults';
import SearchBarWithChips from '../../common/SearchBarWithChips';
import  SearchBarWithChipsGoal from '../../common/SearchBarWithChipsGoal';
import ACLService from '../../../acl/services/aclService';
import { onlyAllowNumbers } from '../../../../utils';
import CreateCoursePopup from '../CreateCoursePopup/CreateCoursePopup';
import { CourseTypes } from '../../types/enums/CourseTypes';
import { TrackRequestProcess } from '../../../content-request/containers/CardData/CardDataTabs';
import ContentShareModel from '../../../course/components/CourseDetail/ContentShareModel';
import { showMsg } from '../../../course/actions/loaderAlert';
import { contentManagementAction } from '../../reducers/contentMangementData';
import { setGetPackageById } from '../../containers/helpers';
import moment from 'moment';
import { getCourseDurationByDate } from './helper/getCourseDurationByDates';
interface CreateNewComboCourseProps {
  goals: Goal[];
  courses: Course[];
  match: any;
  userSuggestions: User[];
  getActiveGoals: Function;
  getActiveCourses: Function;
  getUserSuggestions: Function;
  addCourseBasicDetails: Function;
  setTreeViewData: Function;
  classes: any;
  packageId: string;
  history: any;
  location: any;
  treeDataView: any;
  setTotalGoalsForComboCourse: any;
  showMsg: Function;
  setPackageById: Function;
  setMergedComboCourse: Function;
}

interface CreateNewComboCourseState {
  packageIdForCombo: string;
  formData: CourseBasicDetails;
  formErrors: CourseBasicDetailsErrors;
  activateCreateCourseBtn: boolean;
  activeGoals: string[];
  activeCourses: string[];
  userSuggestions: any[];
  loggedInUserFullName: string;
  clientId: string;
  courseTypes: string[];
  selectedCourseType: string;
  selectedGoals: string[];
  courses: any[];
  goals: any[];
  selectedCourses: string[];
  targetYears: any[];
  primaryCourse: any;
  comboCoursePlan: any;
  nonPrimaryCourses: any[];
  activeComponent: string;
  standardStartDate: string;
  standardEndDate: string;
  values: {value: string, label: string, id: string}[]
  removedSuggestions: any[];
  userId: string;
  shareViewRights:boolean,
  isMyPatClient:boolean
}
class CreateNewComboCourse extends Component<CreateNewComboCourseProps, CreateNewComboCourseState> {
  constructor(props: CreateNewComboCourseProps) {
    super(props);
    const userData = ACLService.getUserDetailsFromStorage();
    const fullName = userData.authenticatedUser.fullName;
    const clientID = userData.authenticatedUser.id;
    this.state = {
      formData: getCreateCourseDefaultFormData({
        id: clientID,
        firstName: fullName.split(' ')[0],
        lastName: fullName.split(' ')[1],
        isRemovable: false,
      }),
      formErrors: getCreateCourseInitailStateForErrors(),
      activateCreateCourseBtn: false,
      activeGoals: [],
      activeCourses: [],
      userSuggestions: [],
      removedSuggestions:[],
      courses: [],
      goals: [],
      comboCoursePlan: {},
      packageIdForCombo: '',
      targetYears: [],
      loggedInUserFullName: '',
      clientId: '',
      courseTypes: ['Standard Course', 'Goals'],
      selectedCourseType: 'Standard Course',
      selectedCourses: [],
      selectedGoals: [],
      primaryCourse: {},
      nonPrimaryCourses: [],
      activeComponent: 'default',
      standardStartDate: '',
      standardEndDate: '',
      values:[],
      userId: '',
      shareViewRights:false,
      isMyPatClient:false
    };
  }

  componentDidMount() {
    const userData = ACLService.getUserDetailsFromStorage();
    
    const clientId = userData.authenticatedUser.aclMetaData.clientId;
    const fullName = userData.authenticatedUser.fullName;
    const clientID = userData.authenticatedUser.id;
    const userId = userData.authenticatedUser._id
    const { values } = this.state
        let updatedValues = [...values, { label: fullName, value: fullName, id: clientID, isRemovable: false}]
           
    this.props.getActiveGoals();
    this.props.getActiveCourses();
    this.props.getUserSuggestions({
      clientId: clientId,
    });

    this.setState({
      loggedInUserFullName: fullName,
      clientId: clientID,
      values: updatedValues,
      userId,
      isMyPatClient:clientId=="5b5702e095cbc921944632a9"
    }, () => this.updateUserSuggestions());
  }

  componentDidUpdate(prevProps: CreateNewComboCourseProps) {
    if (prevProps.courses !== this.props.courses) {
      this.setActiveCourses(this.props.courses);
      const courseName = this.prepareCourseNameSuggestion(this.props.courses);
      
      this.setState({
        courses: courseName,
      });
    }

    if (prevProps.goals !== this.props.goals) {
      this.setActiveGoals(this.props.goals);
      const goalName = this.prepareGoalNameSuggestion(this.props.goals);
      this.setState({
        goals: goalName,
      });
    }

    if (prevProps.userSuggestions !== this.props.userSuggestions) {
      
      const fullNames = this.prepareAdminNameSuggestions(this.props.userSuggestions);
      
      this.setState({
        userSuggestions: fullNames,
      });
    }

    if (prevProps.packageId !== this.props.packageId) {
      
      this.props.history.push(`/course-Management/create-standard-course/${this.props.packageId}`);
    }
  }

  setActiveGoals = (goalData: Goal[]) => {
    const goalNameArray = goalData.map((goal) => goal.name);
    this.setState({
      activeGoals: goalNameArray,
    });
  };

  setActiveCourses = (courseData: Course[]) => {
    const courseNameArray = courseData.map((course) => course.name);
    this.setState({
      activeCourses: courseNameArray,
    });
  };

  validateFormData = (field: string, data?: any) => {
    const { formData, formErrors } = this.state;
    const {
      name,
      sku: { SKUText, SKUNumber, SKUYear },
      courseDetails,
      goalsDetails,
      primaryCourse,
      startDate,
      endDate,
      packageAdmins,
    } = formData;

    switch (field) {
      case 'name':
       this.setState({formErrors: {...this.state.formErrors, name:checkMinLength(name, 5) ? '' : 'Enter atleast 5 characters'}}); 
      
        break;
      case 'sku.SKUText':
        formErrors.sku.SKUText = isContainSpecialCharacters(data) ?'No Special Characters Allowed': checkMinLength(data, 3) ? '' : 'Enter atleast 3 characters';
        break;
      case 'sku.SKUNumber':
        formErrors.sku.SKUNumber = checkMinLength(SKUNumber.toString(), 1) ? '' : 'Enter atleast 1 character';
        break;
      case 'date':
        const dateCheckResult = checkStartAndEndDate(startDate.value, endDate.value);
        switch (dateCheckResult) {
          case DateCheck.startGreaterThanEnd:
            formErrors.startDate = DateCheck.startGreaterThanEnd;
            break;
          case DateCheck.endLessThanStart:
            formErrors.endDate = DateCheck.endLessThanStart;
            break;
          default:
            if(data === "startDate"){
            formErrors.startDate = '';
            } 
            if(data === "endDate") {
              formErrors.endDate = '';
            }
        }
        break;
      case 'goal':
        formErrors.goalsDetails = goalsDetails.length > 0 ? '' : 'Select a goal';
        break;

      case 'course':
        formErrors.courseDetails = courseDetails.length > 0 ? '' : 'Select a course';
        break;
      case 'primaryCourse':
        formErrors.primaryCourse = primaryCourse.length > 0 ? '' : 'Select a primary course';
        break;

        case 'courseAdmins':
                
          formErrors.packageAdmins  =  data !== null
              ? ''
              : 'Select atleast one course admin';
            break;
      default:
    }

    this.setState({
      formErrors: formErrors,
    });
  };

  canActivateCreateCourseBtn = () => {
    const { formErrors } = this.state;
    
    let activateCreateCourseBtn = false;

    let typeCheck = true;
    if (this.state.selectedCourseType === 'Goals') {
      typeCheck =
        formErrors.goalsDetails === '' &&
        formErrors.primaryGoal === '' &&
        formErrors.startDate === '' &&
        formErrors.endDate === ''
          ? true
          : false;
    } else if (this.state.selectedCourseType === 'Standard Course') {
      typeCheck = formErrors.courseDetails === '' && formErrors.primaryCourse === '' ? true : false;
    }

    if (
      typeCheck &&
      formErrors.name === '' &&
      formErrors.sku.SKUText === '' &&
      formErrors.sku.SKUNumber === '' &&
      formErrors.contentPreferences === '' &&
      formErrors.packageAdmins === ''
    ) {
      
      activateCreateCourseBtn = true;
    } else {
      
      activateCreateCourseBtn = false;
    }

    this.setState({
      activateCreateCourseBtn: activateCreateCourseBtn,
    });
  };

  handleChange = (event: any) => {
    const { name, value } = event.target;
    const updatedFormData = { ...this.state.formData };
    const updatedFormErrors = { ...this.state.formErrors };
    switch (name) {
      case 'name':
        
        updatedFormData.name = value.replace(/[^a-zA-Z0-9]/g, "");
        if (updatedFormErrors.name === 'untouched') {
          updatedFormErrors.name = '';
        }
        this.validateFormData('name');
        break;
      case 'skuText':
        updatedFormData.sku.SKUText = value.trim().replace(/[^\w\s]/gi, '');
        if (updatedFormErrors.sku.SKUText === 'untouched') {
          updatedFormErrors.sku.SKUText = '';
        }
        this.validateFormData('sku.SKUText',value.replace(/[^A-Z0-9]/ig, ""));
        break;
      case 'skuNumber':
        updatedFormData.sku.SKUNumber = value.replace(/[^\w\s]/gi, '');
        if (updatedFormErrors.sku.SKUNumber === 'untouched') {
          updatedFormErrors.sku.SKUNumber = '';
        }
        this.validateFormData('sku.SKUNumber');
        break;
      case 'goal':
        updatedFormData.goalsDetails = value;
        if (updatedFormErrors.goalsDetails === 'untouched') {
          updatedFormErrors.goalsDetails = '';
        }
        this.validateFormData('goal');
        break;
      case 'course':
        updatedFormData.courseDetails = value;
        if (updatedFormErrors.courseDetails === 'untouched') {
          updatedFormErrors.courseDetails = '';
        }
        this.validateFormData('course');
        break;

      case 'primaryCourse':
        updatedFormData.primaryCourse = value;
        if (updatedFormErrors.primaryCourse === 'untouched') {
          updatedFormErrors.primaryCourse = '';
        }
        const courseDuration = this.handleStartDateForStandardCourse();
        updatedFormData.duration = courseDuration;
        
        break;

      case 'primaryGoal':
        updatedFormData.primaryGoal = value;
        if (updatedFormErrors.primaryGoal === 'untouched') {
          updatedFormErrors.primaryGoal = '';
        }
        break;

      case 'CourseCreated':
        this.setState({
          selectedCourseType: value,
        });
        break;
      default:
    }
    this.setState(
      {
        formData: updatedFormData,
        formErrors: updatedFormErrors,
      },
      () => {
        console.log(this.state.formData)
        // this.handleStartDateForStandardCourse();
        this.canActivateCreateCourseBtn();
      }
    );
  };

  handleDateSelection = (date: any, type: string) => {
    const updatedFormData = this.state.formData;
    const updatedFormErrors = this.state.formErrors;
    const formattedDate = dateService.dateOnly(date);
    
    switch (type) {
      case 'startDate':
        updatedFormData.startDate.label = formattedDate;
        // updatedFormData.startDate.value = date;
        updatedFormData.startDate.value = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
        updatedFormErrors.startDate = '';
        this.validateFormData('date','startDate');
        break;
      case 'endDate':
        updatedFormData.endDate.label = formattedDate;
        // updatedFormData.endDate.value = date;
        updatedFormData.endDate.value = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");

        updatedFormErrors.endDate = '';
        this.validateFormData('date','endDate');

        const courseDuration = getCourseDurationByDate(updatedFormData.startDate.value, 
          date);
        updatedFormData.duration = courseDuration;
        
        break;
      default:
    }
    this.setState(
      {
        formData: updatedFormData,
        formErrors: updatedFormErrors,
      },
      () => {
        
        this.canActivateCreateCourseBtn();
      }
    );
  };

  handleToggle = (contentType: string) => {
    
    const updatedFormData = this.state.formData;
    const updatedFormErrors = this.state.formErrors;
    switch (contentType) {
      case ContentPreferences.conceptTests:
        updatedFormData.contentPreferences.conceptTests.enabled = !updatedFormData.contentPreferences.conceptTests
          .enabled;
        break;
      case ContentPreferences.video:
        updatedFormData.contentPreferences.video.enabled = !updatedFormData.contentPreferences.video.enabled;
        break;
      case ContentPreferences.chapterTests:
        updatedFormData.contentPreferences.chapterTests.enabled = !updatedFormData.contentPreferences.chapterTests
          .enabled;
        break;
      case ContentPreferences.studyNotes:
        updatedFormData.contentPreferences.studyNotes.enabled = !updatedFormData.contentPreferences.studyNotes.enabled;
        break;
      case ContentPreferences.scheduledTests:
        updatedFormData.contentPreferences.scheduledTests.enabled = !updatedFormData.contentPreferences.scheduledTests
          .enabled;
        break;
      default:
    }

    if (
      updatedFormData.contentPreferences.conceptTests.enabled ||
      updatedFormData.contentPreferences.video.enabled ||
      updatedFormData.contentPreferences.chapterTests.enabled ||
      updatedFormData.contentPreferences.studyNotes.enabled ||
      updatedFormData.contentPreferences.scheduledTests.enabled
    ) {
      updatedFormErrors.contentPreferences = '';
    } else {
      updatedFormErrors.contentPreferences = 'Select atleast one content preference.';
    }

    this.setState(
      {
        formData: updatedFormData,
        formErrors: updatedFormErrors,
      },
      () => {
        
        this.canActivateCreateCourseBtn();
      }
    );
  };

  renderSelectCourseTypeOptions = () => {
    let options: any = [];
    _.map(this.state.courseTypes, (course: string, index: number) =>
      options.push(
        <option key={index} value={course}>
          {course}
        </option>
      )
    );
    return options;
  };

  renderSelectPrimaryCourseOptions = () => {
    let options = [];
    options.push(<option value={''}>{'Select Course'}</option>);
    _.map(this.state.selectedCourses, (course: any, id: number) =>
      options.push(
        <option key={course.id} value={course.name}>
          {course.name}
        </option>
      )
    );
    return options;
  };

  renderSelectPrimaryGoalOptions = () => {
    let options = [];
    
    options.push(<option value={''}>{'Select Primary Goal'}</option>);
    _.map(this.state.selectedGoals, (goal: any, id: number) =>
      options.push(
        <option key={goal.id} value={goal.name}>
          {goal.name}
        </option>
      )
    );
    return options;
  };
  prepareAdminNameSuggestions = (data: User[]) => {
    
    let users = data
      .map((user) => {
        if (user.firstName !== undefined && user.firstName !== null && user._id !== this.state.clientId) return user;
      })
      .filter((user) => user !== undefined)
      .map((user) => ({
        id: user && user._id,
        label: `${user && user.firstName} ${user &&
          user.lastName !== null &&
          user.lastName !== undefined &&
          user.lastName}`,
      }));
    

    return users;
  };

  prepareCourseNameSuggestion = (data: Course[]) => {
    let courseNames = data
      .map((course) => {
        if (course.name !== undefined && course.name !== null) 
        return course;
      })
      .filter((course) => course !== undefined && course.type === 'standard')
      .map((course) => ({
        value: `${course && course.name}`,
        id: course && course._id,
        label: `${course && course.name} `,
      }));
    return courseNames;
  };

  prepareGoalNameSuggestion = (data: Goal[]) => {
    let goalNames = data
      .map((goal) => {
        if (goal.name !== undefined && goal.name !== null) return goal;
      })
      .filter((goal) => goal !== undefined)
      .map((goal) => ({
        value: `${goal && goal.name}`,
        id: goal && goal._id,
        label: `${goal && goal.name} `,
      }));
    return goalNames;
  };

  updateUserSuggestions = () => {
    const { userSuggestions: allUserSuggestions } = this.props;
    const { formData, userSuggestions, values } = this.state;
    const { packageAdmins } = formData;
    let updatedUserSuggestions:any = [];
    let updatedRemovedSuggestions: any = []; 
    updatedRemovedSuggestions.push({id:this.state.clientId, label: this.state.loggedInUserFullName})
    allUserSuggestions.forEach((user) => {
        let addCurrentUser = true;
        const fullName = `${user.firstName} ${user.lastName}`
        values.forEach((admin) => {
            // const adminFullName = `${admin.firstName} ${admin.lastName}`
            if(fullName === admin.label){
                console.log(user)
                updatedRemovedSuggestions.push({id:user._id, label: fullName})
                addCurrentUser = false;
            }
        })
        if(addCurrentUser){
            updatedUserSuggestions.push({id:user._id, label: fullName})
        }
        
    })
    this.setState({
        userSuggestions: updatedUserSuggestions,
        removedSuggestions: updatedRemovedSuggestions
    }, () => console.log(this.state.removedSuggestions))
}

  handleCourseAdminNames = (
    names: { value: string; label: string; id: string }[]
) => {
    // console.log('IN HAndle Course Names------------>', names);
    const validationResult = this.validateFormData('courseAdmins', names);
    // console.log("values before selection", names);
    let updatedFormErrors = {...this.state.formErrors};
    if (names !== null) {
        this.updateUserSuggestions();
        const admins = names.filter((name) => name.id);
        // console.log(admins);
        let selectedAdmins: any = [];
        admins.forEach((admin) => {
            const currentUser = this.props.userSuggestions.filter(
                (user) => user._id === admin.id
            );
            // console.log("current User",currentUser);
            selectedAdmins.push(currentUser[0]);
        });
        // console.log(selectedAdmins)
        const trimmedAdminObjects = selectedAdmins.map((admin: User) => ({
            id: admin._id,
            firstName: admin.firstName,
            lastName: admin.lastName,
            isRemovable: this.state.loggedInUserFullName.toString().includes(`${admin.firstName}`) ?  false : true,
        }));
        // console.log(trimmedAdminObjects);

        let updatedValues = trimmedAdminObjects.map((admin: any) => ({
            label: `${admin.firstName} ${admin.lastName}`,
            value: `${admin.firstName} ${admin.lastName}`,
            id: admin.id,
            // isRemovable: this.state.loggedInUserFullName.toString().includes(`${admin.firstName}`) ?  false : true
            isRemovable: this.state.userId === admin.id ?  false : true
        }))
        // console.log('UPDATED VALUES--------->', updatedValues)

        this.canActivateCreateCourseBtn();
        this.setState((prevState:any)=>{
            let { formData } = prevState;
            let { packageAdmins } = formData;
            
            let updatedFormData = {...formData}
            let updatedPackageAdmins = [...trimmedAdminObjects]

            // packageAdmins = trimmedAdminObjects;
            updatedFormData.packageAdmins = updatedPackageAdmins;
            return {
                formData: updatedFormData,
                formErrors: updatedFormErrors,
                values: updatedValues
            };
         },
            () => {
                // console.log(this.state.formData);

                this.canActivateCreateCourseBtn();
                this.updateUserSuggestions();
            }
        );
    } else {
        // console.log('IN Handle Admin NAmes ELSE---------')
        let { formData } = this.state;
        let { packageAdmins } = formData;
        let updatedFormData = {...formData}
        let updatedPackageAdmins = [...packageAdmins]
        // updatedPackageAdmins = [];
        updatedFormData.packageAdmins = updatedPackageAdmins;
        this.setState({
            formData: updatedFormData
        }, () => this.canActivateCreateCourseBtn())
    }
};

  renderComboCourseTabs = (classes: any) => {
    const { activeComponent } = this.state;
    switch (activeComponent) {
      case 'default':
        return this.handleRenderOfDefaultTab(classes);
      
      
    }
  };

  handleNameChange=(event:any)=>{
    const {value} = event.target;
    if (value !== " ") {
      this.setState({ formData: { ...this.state.formData, name: value.replace(/[^a-zA-Z0-9 /(/)]/g, "") } }, () => {
        if (!checkMinLength(value.trim(), 5)) {
      this.setState({formErrors:{...this.state.formErrors, name: 'Enter atleast 5 characters'}});
    }
    else{
      this.setState({formErrors:{...this.state.formErrors, name: ''}},
      ()=>this.canActivateCreateCourseBtn());
    }}
    );
  }
  }

  handleRenderOfDefaultTab = (classes: any) => {
    const startDate = this.state.formData.startDate.value
      ? new Date(this.state.formData.startDate.value)
      : this.state.formData.startDate.value;

    const endDate = this.state.formData.endDate.value
      ? new Date(this.state.formData.endDate.value)
      : this.state.formData.endDate.value;

    
    return (
      <Modal
      BackdropProps={{ invisible: true }}
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      hideBackdrop={true} //@Neeraj: try to follow the Material UI doc for UI Arch
      className={[
        classes.fontSizeLG,
        classes.fontWeight500,
        classes.modal,
      ].join(" ")}
      open={true}
    >
      <div className={classes.paper}>
        <Card elevation={0} classes={{ root: classes.comboModal}}>
          <DialogHeader
            classes={{ root: classes.comboDialogHeader}}
            urlName='/course-Management'
            selectedTab='Clients'
            iconNode={
              <IconButton
                aria-label='settings'
                
              >
                <CloseIcon
                
                />
              </IconButton>
            }
            headerTitle={
              <>
              <Typography className={classes.courseTitle}>
                Create New Combo Course
              </Typography>
              </>
            }
          />

          <CardContent className={classes.cardContentStyle1}>
            <Grid container justify='center'>
              <Grid item xs={9}>
                <Typography className={classes.cardHeading}>
                  Course Basic Details<span>*</span>{' '}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={8} justify='center'>
              <Grid item xs={9}>
                <Grid container spacing={16}>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>Course Name</Typography>
                    <MyPATTextField
                      
                      fullWidthControl
                      inputId='name'
                      name='name'
                      
                      
                      value={this.state.formData.name || ''}
                      onChange={this.handleNameChange.bind(this)}
                      error={
                        this.state.formErrors.name !== '' && this.state.formErrors.name !== 'untouched' ? true : false
                      }
                      errorText={this.state.formErrors.name}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>SKU</Typography>
                    <Grid container spacing={16}>
                      <Grid item xs={6}>
                        <MyPATTextField
                          
                          fullWidthControl
                          inputId='skuText'
                          name='skuText'
                          placeholder='E.g. JEE'
                          value={this.state.formData.sku.SKUText || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.sku.SKUText !== '' &&
                            this.state.formErrors.sku.SKUText !== 'untouched'
                              ? true
                              : false
                          }
                          errorText={this.state.formErrors.sku.SKUText}
                        />
                        <span className={classes.smallInfo}>Atleast 3 characters </span>
                      </Grid>

                      <Grid item xs={6}>
                        <MyPATTextField
                          fullWidthControl
                          inputId='skuNumber'
                          name='skuNumber'
                          placeholder='01'
                          value={this.state.formData.sku.SKUNumber || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.sku.SKUNumber !== '' &&
                            this.state.formErrors.sku.SKUNumber !== 'untouched'
                              ? true
                              : false
                          }
                          errorText={this.state.formErrors.sku.SKUNumber}
                          onKeyPress={onlyAllowNumbers}
                        />
                        <span className={classes.smallInfo}>Value must be numeric </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container spacing={16} className={classes.mt30}>
                  <Grid item xs={6} className={classes.fullWidthSelect}>
                    <Typography className={classes.inputLable}>Combo Course to be created from</Typography>
                    <MyPATSelect
                      value={this.state.selectedCourseType}
                      name='CourseCreated'
                      onChange={(e: any) => this.handleChange(e)}
                    >
                      {this.renderSelectCourseTypeOptions()}
                    </MyPATSelect>
                  </Grid>
                  {this.state.selectedCourseType === 'Goals' ? (
                    <Grid item xs={6}>
                      <>
                        <Typography className={classes.inputLable}>Select Goal</Typography>
                        <Grid item xs={12}>
                          <SearchBarWithChipsGoal
                            courses={this.state.goals}
                            suggestions={this.state.goals}
                            placeholderText='Select Goal'
                            onSelection={this.handleGoalsNames}
                            classes={{ root: classes.searchBarChips }}
                            backspaceRemoves={true}
                            notFound="No Goal Found"
                          />
                        </Grid>
                      </>
                    </Grid>
                  ) : (
                    <Grid item xs={6}>
                      <>
                        <Typography className={classes.inputLable}>Select Course(s)</Typography>
                        <Grid item xs={12}>
                          <SearchBarWithChips
                            suggestions={this.state.courses}
                            courses={this.state.courses}
                            placeholderText='Select Course'
                            onSelection={this.handleCourseNames}
                            classes={{ root: classes.searchBarChips }}
                            backspaceRemoves={true}
                          />
                        </Grid>
                      </>
                    </Grid>
                  )}
                </Grid>
                {this.state.selectedCourseType === 'Goals' ? (
                  <div>
                    <Grid container spacing={16} className={classes.mt30}>
                      <Grid item xs={6}>
                        <Grid item xs={12} className={classes.fullWidthSelect}>
                          <Typography className={classes.inputLable}>Select Primary Goal</Typography>
                          <MyPATSelect
                            value={this.state.formData.primaryGoal}
                            name='primaryGoal'
                            onChange={(e: any) => this.handleChange(e)}
                          >
                            {this.renderSelectPrimaryGoalOptions()}
                          </MyPATSelect>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container spacing={8}>
                          <Grid item xs={6} className={classes.customCalendar}>
                            <Typography className={classes.inputLable}>Start Date </Typography>
                            <MyPATCalendar
                              fullWidthControl
                              onChange={(dateVal: string) => this.handleDateSelection(dateVal, 'startDate')}
                              date={this.state.formData.startDate.label}
                              placeholder='Select Start Date'
                              // minDate={new Date()}
                            />
                          </Grid>
                          <Grid item xs={6} className={classes.customCalendar}>
                            <Typography className={classes.inputLable}>End Date</Typography>
                            <MyPATCalendar
                              fullWidthControl
                              onChange={(dateVal: string) => this.handleDateSelection(dateVal, 'endDate')}
                              date={this.state.formData.endDate.label}
                              disabled={!startDate}
                              placeholder='Select End Date'
                              minDate={startDate}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  <div>
                    <Grid container spacing={16} className={classes.mt30}>
                      <Grid item xs={6}>
                        <Grid item xs={12} className={classes.fullWidthSelect}>
                          <Typography className={classes.inputLable}>Select Primary Course Plan</Typography>
                          <MyPATSelect
                            value={this.state.formData.primaryCourse}
                            name='primaryCourse'
                            onChange={(e: any) => this.handleChange(e)}
                          >
                            {this.renderSelectPrimaryCourseOptions()}
                          </MyPATSelect>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container spacing={16}>
                          <Grid item xs={6} className={classes.customCalendar}>
                            <Typography className={classes.inputLable}>Start Date </Typography>
                            <MyPATCalendar
                              fullWidthControl
                              onChange={(dateVal: string) => this.handleDateSelection(dateVal, 'startDate')}
                              date={this.state.standardStartDate}
                              disabled={true}
                              placeholder='Select Start Date'
                              // minDate={new Date()}
                            />
                          </Grid>
                          <Grid item xs={6} className={classes.customCalendar}>
                            <Typography className={classes.inputLable}>End Date</Typography>
                            <MyPATCalendar
                              fullWidthControl
                              onChange={(dateVal: string) => this.handleDateSelection(dateVal, 'endDate')}
                              date={this.state.standardEndDate}
                              disabled={true}
                              placeholder='Select End Date'
                              minDate={startDate}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                )}
                {this.state.selectedCourseType === 'Goals' ? (
                  <div>
                    <Grid container spacing={8} justify='flex-start'>
                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel
                          className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color='primary'
                              checked={this.state.formData.contentPreferences.conceptTests.enabled}
                              onChange={() => this.handleToggle(ContentPreferences.conceptTests)}
                            />
                          }
                          label='Do you want Concept Test in this course?'
                          labelPlacement='start'
                        />
                        {/* </FormGroup> */}
                      </Grid>

                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel
                          className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color='primary'
                              checked={this.state.formData.contentPreferences.video.enabled}
                              onChange={() => this.handleToggle(ContentPreferences.video)}
                            />
                          }
                          label='Do you want Videos in this course?'
                          labelPlacement='start'
                        />
                        {/* </FormGroup> */}
                      </Grid>

                      <Grid container spacing={8} justify='flex-start'>
                        <Grid item xs={6}>
                          {/* <FormGroup> */}
                          <FormControlLabel
                            className={classes.updateLabel}
                            control={
                              <Switch
                                classes={{
                                  root: classes.swithMain,
                                  icon: classes.switchIcon,
                                  bar: classes.switchBar,
                                  iconChecked: classes.IscheckedSwitch,
                                  checked: classes.checkedSwitch,
                                }}
                                color='primary'
                                checked={this.state.formData.contentPreferences.chapterTests.enabled}
                                onChange={() => this.handleToggle(ContentPreferences.chapterTests)}
                              />
                            }
                            label='Do you want Chapter Test in this course?'
                            labelPlacement='start'
                          />
                          {/* </FormGroup> */}
                        </Grid>

                        <Grid item xs={6}>
                          {/* <FormGroup> */}
                          <FormControlLabel
                            className={classes.updateLabel}
                            control={
                              <Switch
                                classes={{
                                  root: classes.swithMain,
                                  icon: classes.switchIcon,
                                  bar: classes.switchBar,
                                  iconChecked: classes.IscheckedSwitch,
                                  checked: classes.checkedSwitch,
                                }}
                                color='primary'
                                checked={this.state.formData.contentPreferences.studyNotes.enabled}
                                onChange={() => this.handleToggle(ContentPreferences.studyNotes)}
                              />
                            }
                            label='Do you want Study Notes in this course?'
                            labelPlacement='start'
                          />
                          {/* </FormGroup> */}
                        </Grid>
                      </Grid>

                      <Grid container spacing={8} justify='flex-start'>
                        <Grid item xs={6}>
                          {/* <FormGroup> */}
                          <FormControlLabel
                            className={classes.updateLabel}
                            control={
                              <Switch
                                classes={{
                                  root: classes.swithMain,
                                  icon: classes.switchIcon,
                                  bar: classes.switchBar,
                                  iconChecked: classes.IscheckedSwitch,
                                  checked: classes.checkedSwitch,
                                }}
                                color='primary'
                                checked={this.state.formData.contentPreferences.scheduledTests.enabled}
                                onChange={() => this.handleToggle(ContentPreferences.scheduledTests)}
                              />
                            }
                            label='Do you want Scheduled Test in this course?'
                            labelPlacement='start'
                          />
                          {/* </FormGroup> */}
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ''
                )}
           
                <Grid container spacing={16} className={classes.mt30}>
                  <Grid item xs={6}>
                    <Typography className={[classes.inputLable].join(' ')}>Course Admin</Typography>
                    <SearchBarWithChips
                      suggestions={this.state.userSuggestions}
                      placeholderText="Select Course Admins"
                      onSelection={this.handleCourseAdminNames}
                      // loggedInUserFullName={this.state.loggedInUserFullName}
                      classes={{ root: classes.searchBarChips }}
                      notFound='No User Found'
                      values={this.state.values}
                      isClearable={false}
                      backspaceRemoves={false}
                  />
                  </Grid>
                  <Grid item xs={6}>
                  {this.state.isMyPatClient &&
                     <Grid container alignItems="center"> 
                      <Grid item xs={12}>
                        <Typography
                        style={{marginTop: '20px'}}
                          className={[
                            classes.inputLable
                          ].join(" ")}
                        >
                          Share Course(with view and copy rights)
                        </Typography>
                        <FormControlLabel
                          className={[classes.updateLabel, classes.updatedLabel].join(' ')}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.shareViewRights
                              }
                              onChange={() =>
                                this.setShareEditKey()
                              }
                            />
                          }
                          label="Share this course with FIITJEE Clients?"
                          labelPlacement="start"
                        />
                      </Grid>

                      {/* <Grid item xs={6}>
                   
                      </Grid> */}
                      </Grid>}
                  </Grid>
                </Grid>

              </Grid>

            </Grid>
          </CardContent>

          <DialogFooter
            htmlElements={
              <>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.btnCreateGoal}
                  type='submit'
                  disabled={!this.state.activateCreateCourseBtn}
                  onClick={() => this.handleSubmit(mockData)}
                >
                  Create Course
                </Button>
              </>
            }
          />
        </Card>
        {/* {
                true && 
                <CreateCoursePopup 
                open={true}
                createRequestOpen={true}
                close={false}
                />
        } */}
      </div>
      </Modal>
    );
  };
  setShareEditKey=()=>{
    this.setState({shareViewRights:!this.state.shareViewRights});
 } 
  createPayloadForCreatingComboCourse = (getPackageDetails: any) => {
    let payload: any = {};
    const {
      responseObject: { packageData = {} },
    } = getPackageDetails;
    payload.packageId = packageData._id;
     payload.type = packageData.type;
    // payload.startDate = packageData.startDate;
    payload.startDate = moment(packageData.startDate, "YYYY-MM-DD").format("YYYY-MM-DD");
      // payload.endDate = packageData.expiryDate;
      payload.endDate = moment(packageData.expiryDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    return payload;
  };

  handleRenderOfTree = () => {
    const { treeDataView, setPackageById } = this.props;

    
    let nonPrimaryTree = this.state.nonPrimaryCourses;
    let primaryTree = this.state.nonPrimaryCourses;
    const { comboCoursePlan } = this.state;
    setGetPackageById({ packageId: comboCoursePlan.packageId, setPackageById });
    this.props.history.push(`/course-Management/create-combo-course/${comboCoursePlan.packageId}`);
    
  };
  
  handleCourseNames = (names: { value: string; label: string; id: string }[]) => {
    this.validateFormData('course', names);
    let updatedFormErrors = this.state.formErrors;
    if (names !== null) {
      const courseNames = names.filter((name) => name.id);
      
      let selectedCourses: any = [];
      courseNames.forEach((course) => {
        const currentCourse = this.props.courses.filter((user) => user._id === course.id);
        selectedCourses.push(currentCourse[0]);
      });
      const trimmedCourses = selectedCourses.map((course: Course) => ({
        id: course._id,
        name: course.name,
        isRemovable: true,
      }));
      let { formData } = this.state;
      let { courses } = formData;
      courses = trimmedCourses;
      formData.courses = courses;
      formData.primaryCourse = "";

      updatedFormErrors.courseDetails = '';
      this.setState({
        formData: formData,
        formErrors: updatedFormErrors,
        selectedCourses: trimmedCourses,
      });
    } else {
      let { formData } = this.state;
      let { courses } = formData;
      courses = [];
      formData.courses = courses;
      this.setState({
        formData: formData,
      });
    }
  };
  
  handleGoalsNames = (names: { value: string; label: string; id: string }[]) => {
    this.validateFormData('goal', names);
    let updatedFormErrors = this.state.formErrors;
    if (names !== null) {
      const goalNames = names.filter((name) => name.id);
      let selectedGoals: any = [];
      goalNames.forEach((goal) => {
        const currentGoals = this.props.goals.filter((goalData) => goalData._id === goal.id);
        selectedGoals.push(currentGoals[0]);
      });
      
      const trimmedGoals = selectedGoals.map((goal: Goal) => ({
        id: goal._id,
        name: goal.name,
        isRemovable: true,
      }));
      let { formData } = this.state;
      let { goals } = formData;
      goals = trimmedGoals;
      formData.goals = goals;
      
      updatedFormErrors.goalsDetails = '';
      this.setState({
        formData: formData,
        formErrors: updatedFormErrors,
        selectedGoals: trimmedGoals,
      });
    } else {
      let { formData } = this.state;
      let { goals } = formData;
      goals = [];
      formData.goals = goals;
      this.setState({
        formData: formData,
      });
    }
  };

  prepareGoalsDetailArray = () => {
    let goals: any = [];
    this.state.formData.goals.map((goaldata: any) => {
      let goal = this.props.goals.find((goal) => goaldata.name === goal.name);
      goals.push(goal);
    });
    let goalDataArray: any = [];
    let years: any = [];
    goals.map((goal: any) => {
      if (goal.name === this.state.formData.primaryGoal) {
        years.push(goal.targetYear);
        const goalData = {
          courseId: goal._id,
          courseType: goal.courseType,
          courseName: goal.name,
          primary: 'true',
        };
        goalDataArray.push(goalData);
      } else {
        years.push(goal.targetYear);
        const goalData = {
          courseId: goal._id,
          courseType: goal.courseType,
          courseName: goal.name,
        };
        goalDataArray.push(goalData);
      }
    });
    const returnObj = {
      goalDataArray,
      years,
    };
    return returnObj;
  };

  prepareCourseDetailArray = () => {
    let courses: any = [];
    this.state.formData.courses.map((courseData) => {
      let course = this.props.courses.find((course) => courseData.name === course.name);
      courses.push(course);
    });
    let courseDataArray: any = [];
    let years: any = [];
    courses.map((course: any) => {
      if (course.name === this.state.formData.primaryCourse) {
        course.targetYear.map((year: string) => {
          years.push(year);
        });
        const data = {
          id: course._id,
          name: course.name,
          coursePlanId: course.coursePlanId,
          primary: true,
        };
        courseDataArray.push(data);
      } else {
        course.targetYear.map((year: string) => {
          years.push(year);
        });
        const data = {
          id: course._id,
          name: course.name,
          coursePlanId: course.coursePlanId,
        };
        courseDataArray.push(data);
      }
    });
    const returnObj = {
      courseDataArray,
      years,
    };
    return returnObj;
  };

  getSKUYear = (data : any) => {
    const { formData } = this.state;
    if(formData.primaryGoal) {
      let year = formData.primaryGoal.split("-")[1];
      return year
    } else {
      const length = data.length;
      let skuYear = data[0];
      for (let i = 1; i < length; i++) {
          if(skuYear > data[i]){
            skuYear = data[i];
          }
        }
        return skuYear;
    }

  }
  
  createPackagePayloadForGoal = (data: any) => {
    
    const payload = {
      name: data.name.trim().replace(/[^a-zA-Z0-9/(/) ]/g, ""),
      sku: data.sku,
      startDate: moment(data.startDate).format('YYYY-MM-DD'),
      expiryDate: moment(data.expiryDate).format('YYYY-MM-DD'),
      courseDetails: data.goalsDetails,
      contentPreferences: data.contentPreferences,
      packageAdmins: data.packageAdmins,
      type: 'combo',
      targetYears: data.targetYears,
      duration: data.duration
    };
    
    return payload;
  };
  
  createPackagePayloadForStandard = (data: any) => {
    const payloadData = {
      name: data.name.trim().replace(/[^a-zA-Z0-9 ]/g, ""),
      sku: data.sku,
      startDate: new Date(this.state.standardStartDate),
      expiryDate: new Date(this.state.standardEndDate),
      includedPackages: data.courseDetails,
      packageAdmins: data.packageAdmins,
      type: 'combo',
      targetYears: data.targetYears,
      duration: data.duration
    };
    return payloadData;
  };

  handleStartDateForStandardCourse = () => {

    let courses: any = [];
    this.state.formData.courses.map((courseData) => {
      let course = this.props.courses.find((course) => courseData.name === course.name);
      courses.push(course);
    });
    const length = courses.length;
    courses.map((course: any) => {
      if (course.name === this.state.formData.primaryCourse) {
        console.log(course.startDate, course.expiryDate)
      }});
    let minStartDate = new Date(courses[0].startDate);
    let maxEndDate = new Date(courses[0].expiryDate);
    for (let i = 1; i < length; i++) {
      const currentStartDate = new Date(courses[i].startDate);
      const currentEndDate = new Date(courses[i].expiryDate);
      if (minStartDate.getTime() > currentStartDate.getTime()) {
        minStartDate = currentStartDate
      }
      if (maxEndDate.getTime() < currentEndDate.getTime()) {
        maxEndDate = currentEndDate
      }
    }

    const courseDuration = getCourseDurationByDate(minStartDate.toString(), maxEndDate.toString());
    

    this.setState({
      standardStartDate: minStartDate.toString(),
      standardEndDate: maxEndDate.toString()
    });

    return courseDuration;
  }
  

  createDataForStandardCourse = async (courseData: any, packageId: string) => {
    let primaryData: any = [];
    let secondaryData: any = [];

    const overAllData = courseData.map((course: any) => {
      
      if (course.primary) {
        
        return contentManagementService.getCoursePlanById(course.coursePlanId).then((response) => {
          return Promise.resolve({ primaryData: response });
        });
      } else {
        
        return contentManagementService.getCoursePlanById(course.coursePlanId).then((response) => {
          return Promise.resolve({ secondaryData: response });
        });
      }
    });
    
    
    

    Promise.all(overAllData).then((value: any) => {
      
      let primary: any = [];
      let secondary: any = [];
      // console.log('primaryData', primaryData, secondaryData);
      const allgoals = value.map((ele: any) => {
        if (ele.hasOwnProperty('primaryData')) {
          primary.push(ele.primaryData.coursePlan);
          return contentManagementService.getPackageById(ele.primaryData.coursePlan.packageId).then((response: any) => {
            return Promise.resolve(response.responseObject.packageData.courseDetails);
          });
        } else {
          secondary.push(ele.secondaryData.coursePlan);
          
          return contentManagementService
            .getPackageById(ele.secondaryData.coursePlan.packageId)
            .then((response: any) => {
              
              return Promise.resolve(response.responseObject.packageData.courseDetails);
            });
        }
      });
      Promise.all(allgoals).then((courseDetails: any) => {
        let courseDetail: any = [];
        courseDetails.forEach((ele: any) => {
          ele.forEach((element: any) => {
            courseDetail.push(element);
          });
        });
        this.props.setTotalGoalsForComboCourse(courseDetail);
        // console.log('packageId1', packageId);
        this.setState(
          {
            primaryCourse: primary,
            nonPrimaryCourses: secondary,
            packageIdForCombo: packageId,
          },
          () => {
            courseManagementService.getPackageById(this.state.packageIdForCombo).then((response) => {
              // console.log('checking', this.state.nonPrimaryCourses, this.state.primaryCourse[0]);
              const { startDate , expiryDate } = response.responseObject.packageData;
              const packageData = response.responseObject.packageData;
              let data : any;
              if( this.state.nonPrimaryCourses.length && this.state.primaryCourse[0].length ){}
               
              
              data = mergingTrees(this.state.nonPrimaryCourses, this.state.primaryCourse[0], startDate , expiryDate, packageData);
              
              
              // console.log('dataa', data);
              const { phases, totalPhases, totalTests, weekFormat, subjects } = data;
              let createPayload = this.createPayloadForCreatingComboCourse(response);
              
              createPayload = { ...createPayload, phases, totalPhases, totalTests, weekFormat, subjects };
              
              console.log(createPayload);
              courseManagementService.createCoursePlan(createPayload).then((newCreatedComboCourse) => {
                let {
                  responseObject: { coursePlan = {} },
                } = newCreatedComboCourse;
                coursePlan = { ...coursePlan, phases: JSON.parse(JSON.stringify(data.phases)) };
                this.props.setMergedComboCourse(coursePlan);
                this.props.history.push(
                  `/course-Management/create-combo-course/${packageId}/${this.state.selectedCourseType}`
                );
              });
            });
          }
        );
      });
    });
  };

  handleSubmit = (mockData: any) => {
    
    const typeOfCourse: any = 'Standard Course'; 
    const selectedCourses: any = ['primary', 'basic'];
    const primaryCourse: any = [];
    const { formData, formErrors } = this.state;
    let updatedFormdata = { ...formData };
    let updatedFormErrors = {...formErrors};
    
    updatedFormdata.name = formData.name.trim();
    const { showMsg } = this.props;
    updatedFormdata.type = CourseTypes.combo;
    const goalData = this.prepareGoalsDetailArray();
    updatedFormdata.goalsDetails = goalData.goalDataArray;
    const courseData = this.prepareCourseDetailArray();
    const targetYear = this.state.selectedCourseType === 'Goals' ? goalData.years : courseData.years;
    updatedFormdata.targetYears = targetYear;
    const SKUyear = `${this.getSKUYear(targetYear)}`;
    updatedFormdata.courseDetails = courseData.courseDataArray;
    updatedFormdata.sku = buildComboSKUString(this.state.formData.sku,SKUyear.trim());
    updatedFormdata.startDate = formData.startDate.value;
    updatedFormdata.expiryDate = formData.endDate.value;
    updatedFormdata.duration = formData.duration;
        
    updatedFormdata.isSharedWithFiitjeeClients=this.state.shareViewRights;
    if (this.state.selectedCourseType === 'Goals') {
      if( this.state.selectedGoals.length <= 1 ){
        showMsg('Select more than one goals', 'error' );
      } else {
      const payloadData = this.createPackagePayloadForGoal(updatedFormdata);
      
      const response = contentManagementService
        .createPackage(payloadData)
        .then((res) => {
          if (res.statusCode === 200) {
            res &&
              this.props.history.push(
                `/course-Management/create-combo-course/${res.responseObject.packageDetails._id}/${
                  this.state.selectedCourseType
                }`
              );
          } else {
            updatedFormErrors.sku.SKUText = res.responseMessage;
            this.setState({
              formErrors : updatedFormErrors
            });
          }
        })
        .catch((error) => console.log(error));
      }
    } else {
      if( this.state.selectedCourses.length <= 1 ){
        showMsg('Select more than one courses', 'error' );
      } else {
      const payload = this.createPackagePayloadForStandard(updatedFormdata);
      
      const response = contentManagementService
        .createPackage(payload)
        .then((res) => {
          if (res.statusCode === 200) {
            res && this.createDataForStandardCourse(courseData.courseDataArray, res.responseObject.packageDetails._id);
            updatedFormErrors.sku.SKUText = "";
            this.setState({
              formErrors : updatedFormErrors
            });
          } else if (res.responseMessage === "Duplicate SKU."){
            console.log("else if", typeof res.responseMessage);
            updatedFormErrors.sku.SKUText = 'Please enter a unique SKU';
            this.setState({
              formErrors : updatedFormErrors
            });
          } else {
            console.log("else",typeof res.responseMessage, res.responseMessage);
            console.log(res.responseMessage === "Duplicate SKU")
            showMsg(res.responseMessage, 'error');
          }
        })
        .catch((error) => console.log(error));
      }  
    }
  };

  render() {
    const { classes } = this.props;
    return <>{this.renderComboCourseTabs(classes)}</>;
  }
}

const mapStateToProps = (state: any) => ({
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  courses: state.courseMangementData.courseManagementReducer.activeCourses,
  userSuggestions: state.courseMangementData.courseManagementReducer.userSuggestions,
  packageId: state.courseMangementData.courseManagementReducer.packageId,
  treeDataView: state.courseMangementData.courseManagementReducer.treeDataView,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getActiveGoals: getActiveGoals,
      getActiveCourses: getActiveCourses,
      getUserSuggestions: getUserSuggestions,
      addCourseBasicDetails: addCourseBasicDetails,
      showMsg: showMsg,
      setTotalGoalsForComboCourse: contentManagementAction.setTotalGoalsForComboCourse,
      setPackageById: contentManagementAction.setPackageById,
      setMergedComboCourse: contentManagementAction.setMergedComboCourse,
    },
    dispatch
  );


export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(CreateNewComboCourse)));